﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCustomerOrders = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/customer/classes/models");
const OrderStateEnum_1 = require("../../enums/OrderStateEnum");
const gs_com_modal_dialogs_1 = require("@ivanlog/gs-com-modal_dialogs");
const StateAstra_1 = require("../abstracts/StateAstra");
class StateCustomerOrders extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "My orders", true);
    }
    static InitEventsHandles() {
        const app = StateAstra_1.StateAstra.App;
        app.longPolling.onOrderChanged.addHandler((order) => __awaiter(this, void 0, void 0, function* () {
            if (!app.auth.isAuth)
                return;
            var user = app.auth.session.user;
            if (OrderStateEnum_1.OrderStateEnum[order.state] != OrderStateEnum_1.OrderStateEnum.WaitPay
                && user.id == order.customerId)
                return;
            const req = yield new modalCom.DialogOkNo("Would you like to pay for this order?").show();
            if (req != modalCom.ModalDialogResult.Ok)
                return;
            yield StateCustomerOrders.PayOrderAsync(order);
        }));
    }
    static PayOrderAsync(order) {
        return __awaiter(this, void 0, void 0, function* () {
            yield new modalCom.DialogOkNo("The functionality is no longer available in the admin panel.").show();
            // const app = StateAstra.App;
            // const req =new OrderRequest();
            // req.orderId = order.id;
            // const taked = await app.gui.lockAction(app.api.customer.orders.pay(req));
            // if (!taked) return;
        });
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this._refresh();
            return _super.start.call(this);
        });
    }
    _refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const ordersExt = yield this.lockgui(this.app.api.customer.orders.byQuery(0, 0, 0, 100, false, false, 0));
            const orders = ordersExt.map(o => o.order);
            this.page.ctrls.list.html = '';
            this.page.ctrls.btnNew.hide();
            for (const order of orders) {
                const item = new com.ListItem();
                item.ctrls.lType.text = "Order";
                item.ctrls.lId.text = `#${order.id}`;
                const fromLocation = order.route.locations[0];
                const toLocation = order.route.locations[order.route.locations.length - 1];
                let data = [gs.text.clearHtmlToText(`State: ${order.state}`),
                    gs.text.clearHtmlToText(`From: ${fromLocation.addressFull}`),
                    gs.text.clearHtmlToText(`To: ${toLocation.addressFull}`),
                    gs.text.clearHtmlToText(`Departure time: ${gs.date.getShortTime(order.route.departureTime)}`),
                ];
                if (!order.finalPrice)
                    data.push(gs.text.clearHtmlToText(`Est.price: ${order.estimatedPrice}`));
                else
                    data.push(gs.text.clearHtmlToText(`Final price: ${order.finalPrice}`));
                item.ctrls.pData.html = data.join('<br>');
                this.page.ctrls.list.append(item);
                if (OrderStateEnum_1.OrderStateEnum[order.state] == OrderStateEnum_1.OrderStateEnum.Confirmed)
                    item.onclick = () => __awaiter(this, void 0, void 0, function* () {
                        const modal = yield new modalCom.DialogOkNo("Would you like to cancel this order?").show();
                        if (modal != gs_com_modal_dialogs_1.ModalDialogResult.Ok)
                            return;
                        const req = new models_1.OrderRequest();
                        req.orderId = order.id;
                        const taked = yield this.lockgui(this.app.api.customer.orders.cancel(req));
                        if (!taked)
                            return;
                        yield this._refresh();
                    });
                else if (OrderStateEnum_1.OrderStateEnum[order.state] == OrderStateEnum_1.OrderStateEnum.WaitPay)
                    item.onclick = () => __awaiter(this, void 0, void 0, function* () {
                        const modal = yield new modalCom.DialogOkNo("Would you like to pay for this order?").show();
                        if (modal != gs_com_modal_dialogs_1.ModalDialogResult.Ok)
                            return;
                        yield StateCustomerOrders.PayOrderAsync(order);
                        yield this._refresh();
                    });
                else
                    item.disable();
            }
        });
    }
}
exports.StateCustomerOrders = StateCustomerOrders;
StateCustomerOrders.StateName = "customerOrders";
//# sourceMappingURL=StateCustomerOrders.js.map